
{
  "labels": {
    "enable": "This will make this page available for customers to visit on your website.",
    "update": "This will publish updates made to this page."
  }
}
